import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActionBar } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class ActionBarsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getActionBars() {
    return this.http.get<ActionBar[]>(`${this.BASE_URL}api/action-bars`);
  }
}
